import React from 'react'
import BannerImage from '../images/bannerImage'
import FeaturesCaroussel from '../images/features-caroussel'
import SubTitle from '../sub-title'
import AlternatingList from './alternating-list'

import SEO from '../seo'
import styles from './Home.module.css'

const Home = () => {
  return (
    <section>
      <SEO title="Home" />

      <div className={styles.bannerContainer}>
        <div className={styles.banner}>
          <BannerImage alt="banner showing a past concert" />
        </div>
      </div>

      <h1 className={styles.catchyTitle}>
        We organize exclusive cultural events
      </h1>
      <p className={styles.subTitle}>
        Quality cultural shows all over India, carefully weaving of the program
        and meticulous planning.
      </p>

      <AlternatingList />

      <SubTitle className={styles.featured}>We are featured in...</SubTitle>
      <FeaturesCaroussel />
    </section>
  )
}

export default Home
